<template>
    <div class="bHqwvv">
      <div class="login-bg">
        <div class="ckpClj">
          <img class="logo-image" src="../../assets/image/logo_1.png" alt="logo">
          <span class="nav-top-path">登录</span>
        </div>
        <div class="login-wrapper">
          <div class="login-content">
            <div class="dIsvxy">
              <div class="land_title">经济运行平台-数字底座</div>
                <div class="land_input">
                  <el-input placeholder="请输入" v-model.trim="tel" maxLength="20"  type="text">
                    <template slot="prepend">+86</template>
                  </el-input>
                  <!--<el-input v-model.trim="userName" placeholder="请输入用户名或手机号" maxLength="20"  type="text" ></el-input>
                  <img src="../../assets/image/user_name.png" alt=""> -->
                </div>
                <div class="land_input">
                  <el-input placeholder="输入验证码" v-model.trim="verifyCode" >
                    <el-button slot="append" class="next-btn" :disabled="timeLeft>0" @click="submitVerifyCodeFun" >{{timeLeft>0?timeLeft+'秒':'获取验证码'}}</el-button>
                  </el-input>
                  <!--<el-input v-model.trim="userPassword" placeholder="请输入密码" maxLength="20" type="password"></el-input>
                   <img src="../../assets/image/user_password.png" alt=""> -->
                </div>
                <div>
                  <el-button type="primary" class="land_btn" @click="goLogIn" @keyup.enter="enterLogin">立即登录</el-button>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
          <a href="javascript:void(0)" title="经济运行" >©2018-2025</a> 北京易可诺信息科技有限公司 
          <el-link :underline="false" href="https://beian.miit.gov.cn/">京ICP备18038674号</el-link>
      </div>
      <el-dialog title="" width="420px" :show-close="false" destroy-on-close :visible.sync="sliderVisible" custom-class="verify-dialog">
        <sliderCaptcha @success="sendVerifyCodeFun"></sliderCaptcha>
		  </el-dialog>
    </div>
</template>

<script>
import { ip1 } from '@/assets/js/public.js'
import axios from 'axios';
import {getBrowserInfo} from '@/assets/js/public'
import CryptoJS from 'crypto-js';
import sliderCaptcha from '@/components/land/sliderCaptcha.vue';
export default {
  components: {
    sliderCaptcha
  },
  data(){
    return {
      height:`${document.documentElement.clientHeight}`,
      userName:'',
      userPassword:'',
      tel:'',//手机号
      verifyCode:'',//验证码
      appId:10,
      timeLeft:0,//发送验证码的倒计时
      sliderVisible:false,//发送验证码的滑块对话框
    }
  },
  mounted:function(){
    let t_=this;
    //    一定要在create里面执行一下写的回车事件enterSearch(),否则会执行不了
    t_.enterLogin();
    // document.onkeydown = function (e) {
    //   e = window.event || e
    //   //保证是在登录页面发出的enter事件
    //   if ((t_.$route.path === '/land'||t_.$route.path === '/') && (e.code === 'Enter' || e.code === 'enter')) {
    //     //调用登录函数
    //     t_.goLogIn();
    //   }
    // }
  },
  methods:{
    goLogIn:function(){
      var t_=this
      // if(!t_.userName)return t_.$message({
      //   message:'请填写用户名',
      //   center:true,
      //   type:'warning',
      //   customClass:'zZindex'
      // })
      // if(!t_.userPassword)return t_.$message({
      //   message:'请填写密码',
      //   center:true,
      //   type:'warning',
      //   customClass:'zZindex'
      // })
      if(!t_.tel)return t_.$message({
        message:'请填入手机号',
        center:true,
        type:'warning',
        customClass:'zZindex'
      })
      if(!t_.verifyCode)return t_.$message({
        message:'请输入验证码',
        center:true,
        type:'warning',
        customClass:'zZindex'
      })
      let browser=getBrowserInfo();//浏览器
      var dataObj={
        // username:t_.userName,
        // password:t_.userPassword,
        tel:t_.tel,
        verifyCode:t_.verifyCode,
        loginType:1,//1:短信验证码，3:手机号或用户名+密码登录
        appId:t_.appId,
        ip:localStorage.getItem("ip"),
        browserName:browser[1]+' '+browser[2],
        deviceType:browser[0].replace(';','')
      }
      console.log(dataObj)
      axios.post(`${ip1}api/account/Login`,dataObj).then(res =>{
        console.log('登录信息', res);
        if(res.data.code==20000){
          localStorage.setItem('accessToken',res.data.data.accessToken)
          localStorage.setItem('refreshToken',res.data.data.refreshToken)
          localStorage.setItem('userId',res.data.data.currentUser.userId)
          localStorage.setItem('userName',res.data.data.currentUser.userName)
          localStorage.setItem('appId',t_.appId)
          t_.$router.push({path:'/',query:{}})
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning',
            customClass:'zZindex'
          })
        }
      })
    },
    enterLogin() {
      let t_=this;
      document.onkeydown = e => {
          //console.log(e);
          //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
          // match(此处应填写文件在浏览器中的地址，如 '/login')，不写的话，其他页面也会有调用回车按下的方法
          if (e.key === "Enter" && t_.$route.path === '/land') {
              //回车后执行搜索方法
              t_.goLogIn()
          }
      }
    },
    /**
     * 提交短信验证码，显示验证滑块
     * @param data 
     */
    submitVerifyCodeFun(data){
      console.log('滑块验证码',data)
      let t_=this;
      
      if(!t_.tel)return t_.$message({
        message:'请填入手机号',
        center:true,
        type:'warning',
        customClass:'zZindex'
      })
      t_.sliderVisible=true
    },
    /**
     * 发送验证码
     */
    sendVerifyCodeFun(data){
      let t_=this;
      t_.sliderVisible=false
      if(!t_.tel)return t_.$message({
        message:'请填入手机号',
        center:true,
        type:'warning',
        customClass:'zZindex'
      })
      let params={phone:t_.tel,st:data.st,type:0}
      let headers={}
      // 生成请求ID
      const requestId = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
      headers['X-Request-Source'] = 'WebApp'
      headers['X-Client-Version'] = '1.0.0'
      headers['X-Request-ID'] = requestId
      headers['X-Request-Timestamp'] = Date.now()
      // 生成请求签名
      const nonce = t_.generateNonce()
      const signature = t_.generateRequestSignature(params,nonce, headers['X-Request-Timestamp'])
      headers['X-Request-Signature'] = signature
      headers['X-Request-Nonce'] = nonce
      //调用接口发送验证码
      axios.post(`${ip1}api/account/SendVerifyCode`,params,{headers:headers}).then(res =>{
        console.log('发送验证码',res)
        if(res.data.code==20000){
          //60秒倒计时，按钮不可用
          t_.timeLeft=60;
          let intervalId=setInterval(function() {
              if (t_.timeLeft > 0) {
                  t_.timeLeft -= 1;
              } else {
                  clearInterval(intervalId);
              }
            }, 1000);
        }
      })
    },
    
    // 生成请求签名
    generateRequestSignature(data,nonce, timestamp) {
      const secretKey =  'signature_econo2025'
  
      // 排序参数
      const sortedData = this.sortObject(data)
      const signStr = `${timestamp}${nonce}${JSON.stringify(sortedData)}`
  
      return CryptoJS.HmacSHA256(signStr, secretKey).toString(CryptoJS.enc.Hex)
  },

// 排序对象（用于签名）
 sortObject(obj) {
    let t_=this
    if (obj === null || typeof obj !== 'object') return obj
    
    if (Array.isArray(obj)) {
      return obj.map(t_.sortObject)
    }
    const sorted = {}
    Object.keys(obj).sort().forEach(key => {
      sorted[key] = t_.sortObject(obj[key])
    })
    return sorted
  },
  // 生成随机nonce
  generateNonce() {
    return Math.random().toString(36).substring(2, 15) + 
          Math.random().toString(36).substring(2, 15)
  }
  }
}
</script>
<style scoped>
  
  .bHqwvv {
      height: 100%;
      display: flex;
      flex-direction: column;
      background-color: rgba(215,233,255,0.3);
  }
  .bHqwvv .login-bg {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;
    /* background-size: cover;
    background-attachment: fixed;
    background-image: url('../../assets/image/login_bg.jpg'); */
    background: linear-gradient(to bottom, rgba(240, 240, 240, 1), rgba(198, 210, 246, 0.5));
    padding-bottom: 64px;
}

.ckpClj {
    background: transparent;
    box-shadow: none;
    box-sizing: border-box;
    height: 74px;
    padding: 20px 24px;
}
.logo-image {
    height: 34px;
}
.nav-top-path:before {
    content: "";
    border-left: 1px solid rgba(0, 0, 0, .26);
    height: 16px;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -8px;
}
.nav-top-path {
    font-size: 18px;
    line-height: 34px;
    margin-left: 16px;
    padding-left: 17px;
    position: relative;
}
.login-content {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: center;
    box-sizing: border-box;
    margin: 110px auto 0px;
}
.dIsvxy {
    position: relative;
    width: 430px;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.7);
    min-height: 460px;
    padding: 64px;
    overflow: hidden;
    backdrop-filter: blur(40px);
    -webkit-font-smoothing: antialiased;
}
  .land_title{
    font-size: 22px;
    margin-bottom: 64px;
    text-align: center;
  }
  .land_input{
    position: relative;
    margin-bottom: 40px;
  }
  .next-btn{
    width: 110px;
  }
  .next-btn:hover {
    color: #002FA7;
  }
  .next-btn[disabled]:hover {
    color: #909399;
    background: transparent;
    border-color: transparent;
    text-decoration: none;
  }
  .land_btn{
    width: 100%;
    color: #fff;
    line-height: 40px;
    text-align: center;
    background: #002FA7;
    border-color: #002FA7;
    border-radius: 2px;
    cursor: pointer;
    padding: 0;
  }
  .footer{
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    color: rgb(115, 119, 122);
    letter-spacing: 0.5px;
  }
  .land_input .el-input__inner{
    padding-left: 30px;
  }
  .verify-dialog .el-dialog__body{
    padding: auto;
  }
</style>





// WEBPACK FOOTER //
// src/components/land/land.vue